<p-table [columns]="workFlowHeaders" [value]="masterLists" selectionMode="single" [(selection)]="selectedWorkFlow"
  (onRowSelect)="handleRowSelect($event)">
  <ng-template pTemplate="caption">
    {{title}}
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <ng-container *ngFor="let workFlowField of columns">
        <ng-template [ngIf]="workFlowField.showInGrid">
          <th id="{{workFlowField.field+'Column'}}" [pSortableColumn]="workFlowField.field == 'lab' ? workFlowField.sort:workFlowField.field">
            {{workFlowField.header}}
            <p-sortIcon [field]="workFlowField.field == 'lab' ? workFlowField.sort:workFlowField.field"></p-sortIcon>
          </th>
        </ng-template>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let workFlowCol of columns">
        <ng-template [ngIf]="workFlowCol.showInGrid">
          <td *ngIf="workFlowCol.field != 'lab' && workFlowCol.field != 'active' && workFlowCol.field != 'prelabelledPlates' && workFlowCol.field != 'sampleTypeInFile'" class="wrapword">
            {{rowData[workFlowCol.field]}}
          </td>
          <td *ngIf="workFlowCol.field == 'active' || workFlowCol.field == 'prelabelledPlates' || workFlowCol.field == 'sampleTypeInFile'">
            <p-checkbox disabled [(ngModel)]="rowData[workFlowCol.field]" binary="true"></p-checkbox>
          </td>
          <td *ngIf="workFlowCol.field=='lab'">
            {{rowData[workFlowCol.field]!= null? rowData[workFlowCol.field].name :''}}
          </td>
        </ng-template>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div style="text-align:left">
      <button type="button" pButton icon="pi pi-plus" (click)="handleAddNewWorkFlow()" style="height: 35px;"
        label="Add"></button>
    </div>
  </ng-template>
</p-table>

<p-dialog header="{{title}} Details" [(visible)]="showWorkFlowDialogue" baseZIndex="10"
  [focusOnShow]="false" showEffect="fade" [modal]="true" [style.width]="'800px'" position="top"
  (onHide)="this.showWorkFlowDialogue = false;">
  <div *ngIf="workFlow">
    <div *ngFor="let workFlowField of workFlowHeaders">
      <div class="form-group m-2">
        <div>
          <label>{{workFlowField.header}}</label>
        </div>
        <div *ngIf="workFlowField.field == 'workFlowName' || workFlowField.field == 'properties' || workFlowField.field == 'process' || workFlowField.field == 'arrayPartNumber'">
          <input pInputText class="form-control" [(ngModel)]="workFlow[workFlowField.field]"
            [ngClass]="{error:workFlow[workFlowField.field+'Error']}" [placeholder]="workFlowField.header">
        </div>
        <div *ngIf="workFlowField.field === 'maxArrayIDSize'">
          <p-inputNumber [(ngModel)]="workFlow[workFlowField.field]" inputId="minmax" mode="decimal" [min]="13" [max]="22"> </p-inputNumber>
        </div>
        <div *ngIf="workFlowField.field == 'lab'">
          <p-dropdown [options]="labOptions" [(ngModel)]="workFlow[workFlowField.field]" [filter]="true"
            placeholder="Select a Lab" optionLabel="name" [showClear]="true"
            [styleClass]="workFlow[workFlowField.field+'Error']?'error':''"></p-dropdown>
        </div>
        <div *ngIf="workFlowField.field == 'workFlowGroup'">
          <p-dropdown [options]="workFlowGroupsOptions" [(ngModel)]="workFlow[workFlowField.field]" [filter]="true"
            placeholder="Select MicroArray group" optionLabel="name" [showClear]="true" [autoDisplayFirst]="true"
            [styleClass]="workFlow[workFlowField.field+'Error']?'error':''">
          </p-dropdown>
        </div>
        <div *ngIf="workFlowField.field == 'chipSize'">
          <p-dropdown [options]="chipSizeOptions" [(ngModel)]="workFlow[workFlowField.field]" [filter]="true"
            placeholder="Select ChipSize" optionLabel="name" [showClear]="true" [autoDisplayFirst]="true"
            [styleClass]="workFlow[workFlowField.field+'Error']?'error':''">
          </p-dropdown>
        </div>
        <div *ngIf="workFlowField.field == 'chipLayout'">
          <p-dropdown [options]="chipLayoutOptions" [(ngModel)]="workFlow[workFlowField.field]" [filter]="true"
            placeholder="Select ChipLayout" optionLabel="name" [showClear]="true" [autoDisplayFirst]="true"
            [styleClass]="workFlow[workFlowField.field+'Error']?'error':''">
          </p-dropdown>
        </div>
        <div *ngIf="workFlowField.field == 'controlSchema'">
          <p-dropdown [options]="controlSchemaOptions" [(ngModel)]="workFlow[workFlowField.field]" [filter]="true"
            placeholder="Select control schema" [showClear]="true" [autoDisplayFirst]="true"
            [styleClass]="workFlow[workFlowField.field+'Error']?'error':''">
          </p-dropdown>
        </div>
        <div *ngIf="workFlowField.field == 'processFlow'">
          <p-multiSelect [style]="{'width':'50%'}" [options]="processFlowList" [(ngModel)]="workFlow[workFlowField.field]" [filter]="true" placeholder="Select Process Flow">
          </p-multiSelect>
        </div>
        <div *ngIf="workFlowField.field == 'active' || workFlowField.field == 'prelabelledPlates' || workFlowField.field == 'sampleTypeInFile'">
          <p-checkbox id="active" [(ngModel)]="workFlow[workFlowField.field]" binary="true"></p-checkbox>
        </div>
        <div *ngIf="workFlowField.field == 'proxyWeatherbyAPI'">
          <p-checkbox id="active" [(ngModel)]="workFlow[workFlowField.field]" binary="true"></p-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="ui-dialog-buttonpane ui-helper-clearfix">
    <button type="button" pButton icon="pi pi-check" [disabled]="false" (click)="handleSaveOrUpdate()" label="Save"
      style="float: right; height: 35px;"></button>
  </div>
</p-dialog>
